// extracted by mini-css-extract-plugin
export var externalLink = "_9n-0";
export var internalLinkLabel = "_9n-1";